// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"styles/colors.css\"","primary":"#492172","tooltip":"conN"};


//////////////////
// WEBPACK FOOTER
// ./src/features/CallAnalytics/GraphTooltip/GraphTooltip.scss
// module id = NP+b
// module chunks = 0